// extracted by mini-css-extract-plugin
export default {"baseLayout":"base_baseLayout__Rb0BI"};